<mat-form-field
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel"
        [ngClass]="wrapperClasses">
    <mat-label>{{input.label}}</mat-label>
    <input
        #dateInput
        matInput
        [mtxDatetimepicker]="picker"
        [required]="input.required"
        placeholder="mm/dd/yyyy"
        [aria-describedby]="dateInput.id + editPromptSuffix"
        (blur)="blurEvent($event)"
        (focus)="focusEvent($event)"
        [formControl]="input.control">
    <mtx-datetimepicker-toggle *ngIf="!input.control.disabled" matSuffix [for]="picker"></mtx-datetimepicker-toggle>
    <mtx-datetimepicker #picker [type]="'datetime'" [mode]="'portrait'" [twelvehour]="true"></mtx-datetimepicker>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
    <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>